import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function Identification() {
  return <Section background="dreamy" containerSize="md" className="text-center" data-id="element-202">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} data-id="element-203">
        <h2 className="text-3xl md:text-5xl font-serif italic text-navy mb-10" data-id="element-204">
          Si sos una mujer adulta, esto te va a sonar familiar…
        </h2>

        <div className="space-y-4 text-lg md:text-xl text-navy font-light mb-12 max-w-xl mx-auto" data-id="element-205">
          <p className="bg-cream/70 backdrop-blur-sm py-3 px-6 rounded-full border border-dusty-rose/20" data-id="element-206">
            Llegás a casa cansada.
          </p>
          <p className="bg-cream/70 backdrop-blur-sm py-3 px-6 rounded-full border border-dusty-rose/20" data-id="element-207">
            Sabés que tenés que seguir.
          </p>
          <p className="bg-cream/70 backdrop-blur-sm py-3 px-6 rounded-full border border-dusty-rose/20" data-id="element-208">
            Pero por dentro estás drenada.
          </p>
          <p className="bg-cream/70 backdrop-blur-sm py-3 px-6 rounded-full border border-dusty-rose/20" data-id="element-209">
            Y sentís que todo pesa el doble.
          </p>
        </div>

        <div className="space-y-6 max-w-2xl mx-auto" data-id="element-210">
          <div className="bg-cream/80 backdrop-blur-sm p-8 rounded-[2rem] border-l-4 border-dusty-rose shadow-sm text-left" data-id="element-211">
            <p className="text-base md:text-lg font-light text-navy leading-relaxed" data-id="element-212">
              El problema no es que seas floja. El problema es que nadie te
              enseñó a dejar de perder energía.
            </p>
          </div>
          <div className="bg-cream/80 backdrop-blur-sm p-8 rounded-[2rem] border-l-4 border-dusty-rose shadow-sm text-left" data-id="element-213">
            <p className="text-base md:text-lg font-light text-navy leading-relaxed" data-id="element-214">
              El problema no es que no puedas. El problema es que sostenés
              demasiado con muy poca energía.
            </p>
          </div>
        </div>
      </motion.div>
    </Section>;
}